import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { useAuth } from './context/AuthContext';
import { useTheme } from './components/ThemeContext';
import Dashboard from './components/Dashboard/Dashboard';
import Profile from './components/Profile/Profile';
import Environments from './components/Environments/Environments'; 
import Request from './components/Request/Request';
import Alert from './components/Alert/Alert';
import Login from './components/Login/Login';
import Servers from './components/ServerDevStatus/Servers';
import AddServer from './components/Configuration/AddServer'
import UserAdmin from './components/UserAdmin/UserAdmin';
import Loader from './components/Loader/Loader';

const App = () => {
  const { isAuthenticated, isLoading, login } = useAuth();
  const { theme } = useTheme();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className={`app-loading ${theme}`}>
        <Loader label="Preparing your workspace..." fullscreen />
      </div>
    );
  }

  return (
    <div className={`app-frame ${theme}`}>
      <main className="app-content">
        <Routes>
          <Route 
            path="/" 
            element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login onLoginSuccess={login} />} 
          />
          <Route path="/dashboard" element={isAuthenticated ? <Dashboard /> : <Navigate to="/" />} />
          <Route path="/profile" element={isAuthenticated ? <Profile /> : <Navigate to="/" />} />
          <Route path="/Environments" element={isAuthenticated ? <Environments /> : <Navigate to="/" />} /> 
          <Route path="/addserver" element={isAuthenticated ? <AddServer /> : <Navigate to="/" />} /> 
          <Route path="/Servers" element={isAuthenticated ? <Servers /> : <Navigate to="/" />} />
          <Route path="/Request" element={isAuthenticated ? <Request /> : <Navigate to="/" />} />
          <Route path="/Alert" element={isAuthenticated ? <Alert /> : <Navigate to="/" />} />
          <Route path="/Users" element={isAuthenticated ? <UserAdmin /> : <Navigate to="/" />} />
        </Routes>
      </main>
      {!isAuthenticated && (
        <footer className="app-footer">
          <span>© 2026 MBS Monitoring · Made by <a href="https://mbs-digitals.com" target="_blank" rel="noreferrer">mbs-digitals.com</a></span>
        </footer>
      )}
    </div>
  );
};

export default App;
